import React, { useRef } from 'react';
import emailjs from "@emailjs/browser";

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs.sendForm('service_obepwxr', 'template_6hs0x5b', form.current, 'JVtJiwB01Rhx77VcN');
    e.target.reset();
  };

  const sendAlert = () => {
    alert("Your message has been sent!");
  };

  return (
    <div className="max-w-[1100px] mx-auto p-4 md:p-8 lg:p-12">
      <div className="text-5xl text-center font-bold mt-20">Contact Us</div>
      <form ref={form} className="mt-20" onSubmit={sendEmail}>
        <label htmlFor="" className='text-2xl font-bold font-[Montserrat]'>Name</label>
        <input type="text" name='name' className="border border-gray-400 rounded-md w-full my-2 h-12" placeholder=' Your Name' />
        
        <label htmlFor="" className='text-2xl font-bold font-[Montserrat]'>Email</label>
        <input type="email" name='email' className="border border-gray-400 rounded-md w-full my-2 h-12" placeholder=' Your Email' />
        
        <label htmlFor="" className='text-2xl font-bold font-[Montserrat]'>Contact Number</label>
        <input type="number" name='number' className="border border-gray-400 rounded-md w-full my-2 h-12" placeholder=' Your Contact Number' />
        
        <label htmlFor="" className='text-2xl font-bold font-[Montserrat]'>Subject</label>
        <input type="text" name='purpose' className="border border-gray-400 rounded-md w-full my-2 h-12" placeholder=' Your Message' />
        
        <button onClick={sendAlert} className='bg-prime flex items-center justify-center text-white font-[Poppins] p-4 rounded md:ml-0 hover:bg-indigo-400 duration-500 mt-8 w-full mb-40'>SUBMIT</button>
      </form>
    </div>
  );
};

export default Contact;